var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "dash_svg__icon",
    viewBox: "0 0 512 512",
    height: "1em",
    width: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 256c0-24 16-43 36-43h440c20 0 36 19 36 43s-16 43-36 43H36c-20 0-36-19-36-43z"
  })));
}
export default __webpack_public_path__ + "fonts/dash-dd77240ad8a076578a558d7ee1f3ad13.svg";
export { SvgDash as ReactComponent };